import listeningTogether from './listening-together.webp';
import forest from './forest.webp';
import familySmiling from './family-smiling.webp';
import guyListeningWithHeadphones from './guy-listening-headphones.webp';
import manListeningIntently from './man-listening-intently.webp';
import headphones from './headphones.webp';
import earCloseUp from './ear-close-up.webp';
import earWithSoundWaves from './ear-with-soundwaves.webp';
import norcStart from './norc-start.webp';
import normalHearingIcon from './normal.webp';
import mildHearingIcon from './mild.webp';
import severeHearingIcon from './severe.webp';
import norcVolumeSetting from './norc-volume-setting.webp';
import norcReferenceNumber from './norc-reference-number.webp';
import norcSelectBirthYear from './norc-select-birth-year.webp';
import norcInWhichEarDoYouHearTheSound from './norc-in-which-ear-do-you-hear-the-sound.webp';
export var pageImages = {
    guyListeningWithHeadphones: guyListeningWithHeadphones,
    listeningTogether: listeningTogether,
    forest: forest,
    familySmiling: familySmiling,
    manListeningIntently: manListeningIntently,
    headphones: headphones,
    earCloseUp: earCloseUp,
    earWithSoundWaves: earWithSoundWaves,
    norcVolumeSetting: norcVolumeSetting,
    norcSelectBirthYear: norcSelectBirthYear,
    norcStart: norcStart,
    norcInWhichEarDoYouHearTheSound: norcInWhichEarDoYouHearTheSound,
    normalHearingIcon: normalHearingIcon,
    mildHearingIcon: mildHearingIcon,
    severeHearingIcon: severeHearingIcon,
    norcReferenceNumber: norcReferenceNumber,
};
